import React from 'react';
import styles from './Post.module.scss';
import { Link } from 'gatsby';

const Post = ({ post }) => {
  const { html } = post;
  const { tagSlugs } = post.fields;
  const { tags, title, date } = post.frontmatter;
  const dateObj = new Date(date);

  return (
    <div className={styles['post']}>
      <div className={styles['post__content']}>
        <h1 className={styles['post__content__title']}>{title}</h1>
        <div className={styles['post__content__meta']}>
          <div className={styles['post__content__meta__date']}>
            {`${dateObj.toLocaleString('default', {
              month: 'short',
            })} ${dateObj.getDate()}`}
          </div>

          <div className={styles['post__content__meta__tags']}>
            {tagSlugs &&
              tagSlugs.map((slug, i) => (
                <Link to={slug} className={styles['post__content__meta__tags']}>
                  #{tags[i]}
                </Link>
              ))}
          </div>
        </div>

        <div
          className={styles['post__content__body']}
          dangerouslySetInnerHTML={{ __html: html }}
        />
      </div>
    </div>
  );
};

export default Post;
